import { render, staticRenderFns } from "./res-banner.mpx?vue&type=template&id=4b2f6f1c&scoped=true&isComponent&outputPath=components%2Fres-bannercf025d98%2Findex"
import script from "./res-banner.mpx?vue&type=script&lang=js&isComponent&outputPath=components%2Fres-bannercf025d98%2Findex"
export * from "./res-banner.mpx?vue&type=script&lang=js&isComponent&outputPath=components%2Fres-bannercf025d98%2Findex"
import style0 from "./res-banner.mpx?vue&type=style&index=0&id=4b2f6f1c&prod&lang=stylus&scoped=true&mpxStyleOptions=%7B%22mid%22%3A%22mcf025d98%22%7D&isComponent&outputPath=components%2Fres-bannercf025d98%2Findex"
import style1 from "./res-banner.mpx?vue&type=style&index=1&id=4b2f6f1c&prod&lang=stylus&mpxStyleOptions=%7B%22mid%22%3A%22mcf025d98%22%7D&isComponent&outputPath=components%2Fres-bannercf025d98%2Findex"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b2f6f1c",
  null
  
)

export default component.exports